var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_81_497)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55.25,
    cy: 51.25,
    r: 51.25,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.6832 74.114C68.762 74.114 79.3645 63.51 79.3645 50.4294C79.3645 37.3487 68.762 26.7448 55.6832 26.7448C42.6044 26.7448 32.002 37.3487 32.002 50.4294C32.002 63.51 42.6044 74.114 55.6832 74.114Z",
    fill: "url(#paint0_radial_81_497)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M55.6832 74.114C68.762 74.114 79.3645 63.51 79.3645 50.4294C79.3645 37.3487 68.762 26.7448 55.6832 26.7448C42.6044 26.7448 32.002 37.3487 32.002 50.4294C32.002 63.51 42.6044 74.114 55.6832 74.114Z",
    fill: "url(#paint1_radial_81_497)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M79.2388 53.0238C75.7662 51.0152 71.7495 49.8854 67.44 49.8854C55.2228 49.8854 45.1813 59.1332 43.8843 71.0173C47.357 73.0259 51.3736 74.1558 55.6831 74.1558C67.9003 74.1558 77.9418 64.9079 79.2388 53.0238Z",
    fill: "url(#paint2_radial_81_497)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1943 49.6761C57.7755 44.1524 62.9637 34.6954 60.8717 27.3305C59.1981 26.9539 57.4408 26.7446 55.6417 26.7446C42.5459 26.7446 31.9604 37.3734 31.9604 50.4292C31.9604 51.5172 32.0441 52.5634 32.1697 53.6095C37.1067 54.028 42.8387 52.7307 48.1524 49.6342L48.1943 49.6761Z",
    fill: "url(#paint3_radial_81_497)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7503 44.7382C51.7503 46.4957 50.3277 47.9185 48.5705 47.9185C46.8132 47.9185 45.3906 46.4957 45.3906 44.7382C45.3906 42.9807 46.8132 41.558 48.5705 41.558C50.3277 41.558 51.7503 42.9807 51.7503 44.7382Z",
    fill: "url(#paint4_radial_81_497)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9344 44.7381C65.9344 46.4956 64.5118 47.9184 62.7546 47.9184C60.9973 47.9184 59.5747 46.4956 59.5747 44.7381C59.5747 42.9806 60.9973 41.5579 62.7546 41.5579C64.5118 41.5579 65.9344 42.9806 65.9344 44.7381Z",
    fill: "url(#paint5_radial_81_497)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4695 55.3253C63.8838 55.3253 63.3817 55.7438 63.298 56.3296C62.7122 59.3844 59.5324 61.7277 55.725 61.7277C51.9176 61.7277 48.7378 59.3844 48.152 56.3296C48.0265 55.7438 47.5663 55.3253 46.9805 55.3253C46.2274 55.3253 45.6417 56.0367 45.809 56.7899C46.6458 60.7234 50.788 63.7363 55.7669 63.7363C60.7458 63.7363 64.8879 60.7234 65.7247 56.7899C65.892 56.0367 65.3063 55.3253 64.5532 55.3253H64.4695Z",
    fill: "url(#paint6_radial_81_497)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_81_497",
    x: 0,
    y: 0,
    width: 110.5,
    height: 110.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_81_497"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_81_497",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_81_497",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.6832 50.4294) scale(23.6813 23.6846)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF9A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FFCD2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD52E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_81_497",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.6957 52.5216) scale(42.1744 42.1804)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#070804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1D1E11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#727543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#B2B668"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FF92"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_81_497",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.4065 76.7502) scale(23.6813 23.6845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FF934C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFB280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFE3D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_81_497",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.6224 36.3535) rotate(-30.0035) scale(19.6988 13.2562)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "white",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "white",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_81_497",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5704 44.7383) scale(3.17982 3.18027)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#852F17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#822D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#782813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#68200F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#631E0E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_81_497",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.7545 44.7381) scale(3.17982 3.18027)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#852F17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#822D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#782813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#68200F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#631E0E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_81_497",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.6832 59.5099) scale(7.65665 7.65778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#852F17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#822D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#782813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#68200F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#631E0E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.4aea205b7c8fbffe3f91c3e5187bdf28.svg";
export { ForwardRef as ReactComponent };